"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[104],{

/***/ 15840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95934);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _styles_fontStyles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30423);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        ";\n    height: 48px;\n    padding: 0;\n    border-radius: 8px;\n    width: 320px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        ";\n    height: 36px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        ";\n    height: 32px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    color: ",
        ";\n    background-color: initial;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

/* eslint-disable react/jsx-props-no-spreading */ 




function Button(_param) {
    var _color = _param.color, color = _color === void 0 ? "outlined" : _color, _size = _param.size, size = _size === void 0 ? "medium" : _size, href = _param.href, children = _param.children, _type = _param.type, type = _type === void 0 ? "button" : _type, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "color",
        "size",
        "href",
        "children",
        "type"
    ]);
    var htmlProps = rest;
    if (href) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledLink, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                color: color,
                size: size
            }, htmlProps), {
                children: children
            }))
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        color: color,
        size: size,
        type: type
    }, htmlProps), {
        children: children
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Button);
var ButtonWrapper = function(param) {
    var color = param.color, size = param.size, theme = param.theme;
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)('position:relative;transform:translateZ(0);user-select:none;transition:color .1s ease-in-out,background-color .1s ease-in-out,border-color .1s ease-in-out,opacity .1s ease-in-out;white-space:nowrap;overflow:hidden;display:flex;flex-direction:row;align-items:center;justify-content:center;text-align:center;padding:0 1rem;border-radius:6px;@media(hover:hover) and (pointer:fine){&:not(:disabled):after{content:" ";position:absolute;top:0;right:0;bottom:0;left:0;background-color:', theme.foreground, ";opacity:0;transition:opacity .1s ease-in-out;}&:not(:disabled):not(.disabled):hover:after{opacity:0.15;}}", size === "large" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject(), (0,_styles_fontStyles__WEBPACK_IMPORTED_MODULE_9__/* .h4Font */ .QY)(true)), ";", size === "medium" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject1(), (0,_styles_fontStyles__WEBPACK_IMPORTED_MODULE_9__/* .body1Font */ .Nr)(true)), ";", size === "small" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject2(), (0,_styles_fontStyles__WEBPACK_IMPORTED_MODULE_9__/* .body2Font */ .ll)(true)), ";", color === "outlined" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject3(), theme.foreground, theme.background, theme.accent2), " ", color === "success" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject4(), theme.background, theme.success), " ", color === "primary" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject5(), theme.background, theme.accent8), " ", color === "warning" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject6(), theme.background, theme.warning), " ", color === "ghost" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject7(), theme.foreground), "  &:disabled{color:", theme.accent4, ";background-color:", theme.accent1, ";}");
};
var StyledLink = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("a", {
    target: "eg74q0n0"
})(ButtonWrapper);
var StyledButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button", {
    target: "eg74q0n1"
})(ButtonWrapper);


/***/ }),

/***/ 98145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4480);
/* harmony import */ var _recoil_group_atom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84029);
/* harmony import */ var _styles_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(622);
/* harmony import */ var _styles_responsive__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50811);
/* harmony import */ var _styles_zIndexes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63597);
/* harmony import */ var _assets_icons_img_logo_soople_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33705);












function HeaderWrapper(param) {
    var hasBackground = param.hasBackground, isScrollTop = param.isScrollTop, testId = param.testId, children = param.children;
    var setGroupsCondition = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useSetRecoilState */ .Zl)(_recoil_group_atom__WEBPACK_IMPORTED_MODULE_4__/* .groupsConditionState */ .c);
    var onClickLogo = function() {
        return setGroupsCondition(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prev), {
                category: [
                    "study",
                    "project"
                ],
                tag: ""
            });
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(HeaderBlock, {
                hasBackground: hasBackground,
                isScrollTop: isScrollTop,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(HeaderContents, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/",
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("a", {
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(LogoIcon, {
                                    onClick: onClickLogo
                                })
                            })
                        }),
                        children
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(Spacer, {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(HeaderWrapper));
var LogoIcon = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_assets_icons_img_logo_soople_svg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    target: "e7tciby0"
})("width:96px;height:24px;");
var HeaderBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e7tciby1"
})("position:fixed;width:100%;z-index:", _styles_zIndexes__WEBPACK_IMPORTED_MODULE_7__/* ["default"].TopNavigation */ .Z.TopNavigation, ";background:", function(param) {
    var hasBackground = param.hasBackground, theme = param.theme;
    return hasBackground ? theme.accent1 : theme.background;
}, ";box-shadow:0 1px 0 0 ", function(param) {
    var isScrollTop = param.isScrollTop, theme = param.theme;
    return isScrollTop ? "transparent" : theme.accent2;
}, ";transition:box-shadow .2s ease-in-out;");
var Spacer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e7tciby2"
})("height:4rem;");
var HeaderContents = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_styles_Layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e7tciby3"
})("display:flex;flex-direction:row;align-items:center;justify-content:space-between;height:4rem;", (0,_styles_responsive__WEBPACK_IMPORTED_MODULE_6__/* .mq2 */ .v6)({
    width: [
        "calc(100% - 3rem)",
        "calc(100% - 3rem)",
        "calc(100% - 3rem)",
        "800px",
        "1040px"
    ]
}), ";");


/***/ }),

/***/ 52235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95934);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    cursor: pointer;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function ProfileImage(param) {
    var src = param.src, _alt = param.alt, alt = _alt === void 0 ? "\uD504\uB85C\uD544 \uC774\uBBF8\uC9C0" : _alt, _size = param.size, size = _size === void 0 ? "32px" : _size, onClick = param.onClick;
    if (!src) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ProfileAvatarImage, {
            src: "/img_avatar_default.png",
            alt: alt,
            width: size,
            height: size,
            style: {
                minHeight: size,
                minWidth: size
            },
            onClick: onClick
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ProfileAvatarImage, {
        src: src,
        alt: alt,
        width: size,
        height: size,
        style: {
            minHeight: size,
            minWidth: size
        },
        onClick: onClick
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ProfileImage);
var ProfileAvatarImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("img", {
    target: "eovc71d0"
})("border-radius:70%;overflow:hidden;", function(param) {
    var onClick = param.onClick;
    return onClick && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject());
}, ";");


/***/ }),

/***/ 71178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95934);
/* harmony import */ var _styles_transitions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80977);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border-radius: 50%;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* eslint-disable react/jsx-props-no-spreading */ 



function SkeletonItem(_param) {
    var circle = _param.circle, className = _param.className, styles = _param.styles, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "circle",
        "className",
        "styles"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SkeletonBlock, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        style: styles,
        circle: circle,
        className: className
    }, rest));
}
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonItem);
var SkeletonBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("span", {
    target: "e1i463g80"
})("user-select:none;box-sizing:border-box;background:", function(param) {
    var theme = param.theme;
    return theme.accent2;
}, ";animation:", _styles_transitions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].blink */ .Z.blink, " 1s ease-in-out infinite;display:inline-block;border-radius:4px;height:1em;", function(param) {
    var circle = param.circle;
    return circle && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject());
});


/***/ }),

/***/ 89104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_HeaderContainer; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./src/components/common/Button.tsx
var Button = __webpack_require__(15840);
// EXTERNAL MODULE: ./src/components/common/HeaderWrapper.tsx
var HeaderWrapper = __webpack_require__(98145);
// EXTERNAL MODULE: ./src/components/common/SkeletonItem.tsx
var SkeletonItem = __webpack_require__(71178);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react-feather/dist/icons/bell.js
var bell = __webpack_require__(77424);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useClickAway.js
var useClickAway = __webpack_require__(69293);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js + 2 modules
var emotion_element_cbed451f_browser_esm = __webpack_require__(9570);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/services/api/alarm.ts
var alarm = __webpack_require__(1249);
// EXTERNAL MODULE: ./src/utils/utils.ts
var utils = __webpack_require__(55208);
// EXTERNAL MODULE: ./src/hooks/api/auth/useFetchUserProfile.ts
var useFetchUserProfile = __webpack_require__(8576);
// EXTERNAL MODULE: ./src/hooks/api/useCatchFirestoreErrorWithToast.ts
var useCatchFirestoreErrorWithToast = __webpack_require__(15989);
;// CONCATENATED MODULE: ./src/hooks/api/alarm/useFetchAlertAlarms.ts







function useFetchAlertAlarms() {
    var ref = (0,useFetchUserProfile/* default */.Z)(), user = ref.data;
    var query = (0,react_query_es.useQuery)([
        "alertAlarms"
    ], function() {
        return (0,alarm/* getUserAlertAlarm */.Fj)(user === null || user === void 0 ? void 0 : user.uid);
    }, {
        enabled: !!user
    });
    var isError = query.isError, error = query.error, data = query.data;
    (0,useCatchFirestoreErrorWithToast/* default */.Z)({
        isError: isError,
        error: error,
        defaultErrorMessage: "\uC54C\uB78C\uC744 \uBD88\uB7EC\uC624\uB294\uB370 \uC2E4\uD328\uD588\uC5B4\uC694!"
    });
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
        data: (0,utils/* checkEmpty */.TM)(data)
    });
}
/* harmony default export */ var alarm_useFetchAlertAlarms = (useFetchAlertAlarms);

// EXTERNAL MODULE: ./src/hooks/useBoolean.ts
var useBoolean = __webpack_require__(53740);
// EXTERNAL MODULE: ./src/hooks/useResponsive.ts
var useResponsive = __webpack_require__(10653);
// EXTERNAL MODULE: ./src/styles/fontStyles.ts
var fontStyles = __webpack_require__(30423);
;// CONCATENATED MODULE: ./src/components/common/DropDown.tsx






function DropDown(param) {
    var isVisible = param.isVisible, name = param.name, email = param.email, numberAlertAlarms = param.numberAlertAlarms, signOut = param.signOut;
    if (!isVisible) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropDownWrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "menu-wrapper",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "content-wrapper",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UserState, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "user-name",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "user-email",
                                    children: email
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: "/myinfo/setting",
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyInfoMenu, {
                                children: "\uB0B4 \uC815\uBCF4"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: "/alarm",
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MyInfoMenu, {
                                className: "my-alarm",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        children: "\uB0B4 \uC54C\uB9BC"
                                    }),
                                    !!numberAlertAlarms && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AlertAlarmStatus, {
                                        children: numberAlertAlarms
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pipe, {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "content-wrapper",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuContent, {
                        onClick: signOut,
                        children: "\uB85C\uADF8\uC544\uC6C3"
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var common_DropDown = (/*#__PURE__*/(0,react.memo)(DropDown));
var DropDownWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emcajle0"
})("position:absolute;top:100%;margin-top:0.25rem;right:0;.menu-wrapper{position:relative;z-index:5;min-width:175px;background:", function(param) {
    var theme = param.theme;
    return theme.background;
}, ";border-radius:8px;box-shadow:rgb(0 0 0 / 10%) 0px 0px 5px;}.content-wrapper{padding:4px 0px;}");
var Pipe = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emcajle1"
})("margin:0;border-top:1px solid ", function(param) {
    var theme = param.theme;
    return theme.accent2;
}, ";");
var UserState = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emcajle2"
})("display:flex;flex-direction:column;padding:8px 40px 8px 16px;justify-content:flex-start;.user-name{", (0,fontStyles/* body1Font */.Nr)(true), ";}.user-email{", (0,fontStyles/* subtitle1Font */.T7)(), ";color:", function(param) {
    var theme = param.theme;
    return theme.accent5;
}, ";}");
var navItem = function(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0,emotion_react_browser_esm.css)((0,fontStyles/* body1Font */.Nr)(), ";color:", theme.foreground, ";padding:0.5rem 1rem;cursor:pointer;transition:background-color .2s;&:hover{background:", theme.accent1, ";}");
};
var MenuContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emcajle3"
})(navItem);
var MyInfoMenu = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "emcajle4"
})(navItem, "  display:block;&.my-alarm{display:flex;flex-direction:row;align-items:center;}");
var AlertAlarmStatus = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emcajle5"
})((0,fontStyles/* subtitle2Font */.o$)(true), "  text-align:center;background-color:", function(param) {
    var theme = param.theme;
    return theme.warning;
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.background;
}, ";width:16px;height:16px;border-radius:16px;margin-left:4px;");

// EXTERNAL MODULE: ./src/components/common/ProfileImage.tsx
var ProfileImage = __webpack_require__(52235);
;// CONCATENATED MODULE: ./src/components/common/UserNavbar.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-left: 16px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}















function UserNavbar(param) {
    var user = param.user, signOut = param.signOut;
    var isMobile = (0,useResponsive/* default */.Z)().isMobile;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var ref = alarm_useFetchAlertAlarms(), alertAlarms = ref.data;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useBoolean/* default */.Z)(false), 4), isVisibleDropDownMenu = ref1[0], closeDropDownMenu = ref1[2], onToggle = ref1[3];
    var userIconRef = (0,react.useRef)(null);
    (0,useClickAway/* default */.Z)(userIconRef, closeDropDownMenu, [
        "mousedown",
        "scroll",
        "touchstart"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UserNavbarWrapper, {
        isMobile: isMobile,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                size: "small",
                href: "/write",
                children: "\uD300 \uBAA8\uC9D1\uD558\uAE30"
            }),
            !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/alarm",
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AlarmLink, {
                    className: "alarm-icon",
                    children: [
                        !(0,utils/* isEmpty */.xb)(alertAlarms) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserNavbar_AlertAlarmStatus, {
                            children: alertAlarms.length
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bell/* default */.Z, {
                            color: theme.accent6
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "profile-dropdown-wrapper",
                ref: userIconRef,
                children: [
                    isMobile && !(0,utils/* isEmpty */.xb)(alertAlarms) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserNavbar_AlertAlarmStatus, {
                        children: alertAlarms.length
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileImage/* default */.Z, {
                        src: user.image,
                        onClick: onToggle
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(common_DropDown, {
                        signOut: signOut,
                        name: user.name,
                        email: user.email,
                        isVisible: isVisibleDropDownMenu,
                        numberAlertAlarms: alertAlarms.length
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var common_UserNavbar = (/*#__PURE__*/(0,react.memo)(UserNavbar));
var UserNavbarWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ldh5u40"
})("display:flex;flex-direction:row;align-items:center;.alarm-icon{margin:0 22px;}.profile-dropdown-wrapper{", function(param) {
    var isMobile = param.isMobile;
    return isMobile && (0,emotion_react_browser_esm.css)(_templateObject());
}, "    position:relative;}");
var AlarmLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e1ldh5u41"
})("position:relative;");
var UserNavbar_AlertAlarmStatus = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ldh5u42"
})((0,fontStyles/* subtitle2Font */.o$)(true), "  position:absolute;text-align:center;background-color:", function(param) {
    var theme = param.theme;
    return theme.warning;
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.background;
}, ";top:-4px;right:-4px;width:16px;height:16px;border-radius:16px;");

;// CONCATENATED MODULE: ./src/components/common/Header.tsx







function Header(param) {
    var user = param.user, onClick = param.onClick, isScrollTop = param.isScrollTop, signOut = param.signOut, hasBackground = param.hasBackground, hasOnlyLogo = param.hasOnlyLogo, isLoading = param.isLoading;
    if (hasOnlyLogo) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderWrapper/* default */.Z, {
            hasBackground: hasBackground,
            isScrollTop: isScrollTop,
            testId: "only-logo-block"
        });
    }
    if (isLoading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderWrapper/* default */.Z, {
            hasBackground: hasBackground,
            isScrollTop: isScrollTop,
            testId: "header-block",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoaderWrapper, {
                title: "loading-skeleton",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkeletonItem/* default */.Z, {
                        styles: {
                            width: "80px",
                            height: "28px",
                            margin: "0 16px 0 0",
                            borderRadius: "6px"
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkeletonItem/* default */.Z, {
                        styles: {
                            width: "32px",
                            height: "32px",
                            minWidth: "32px",
                            minHeight: "32px"
                        },
                        circle: true
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderWrapper/* default */.Z, {
        hasBackground: hasBackground,
        isScrollTop: isScrollTop,
        testId: "header-block",
        children: user ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(common_UserNavbar, {
            signOut: signOut,
            user: user
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            size: "small",
            type: "button",
            onClick: onClick,
            children: "\uC2DC\uC791\uD558\uAE30"
        })
    });
}
/* harmony default export */ var common_Header = (/*#__PURE__*/(0,react.memo)(Header));
var LoaderWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ensppgc0"
})("display:flex;flex-direction:row;align-items:center;");

// EXTERNAL MODULE: ./src/services/api/auth.ts
var auth = __webpack_require__(59155);
// EXTERNAL MODULE: ./src/hooks/api/useCatchAuthErrorWithToast.ts
var useCatchAuthErrorWithToast = __webpack_require__(26884);
;// CONCATENATED MODULE: ./src/hooks/api/auth/useSignOut.ts





function useSignOut() {
    var replace = (0,router.useRouter)().replace;
    var queryClient = (0,react_query_es.useQueryClient)();
    var mutation = (0,react_query_es.useMutation)(function() {
        return (0,auth/* postSignOut */.MN)();
    }, {
        onSuccess: function() {
            (0,utils/* removeToken */.gy)();
            queryClient.setQueryData([
                "user"
            ], function() {
                return null;
            });
            queryClient.setQueryData([
                "token"
            ], function() {
                return null;
            });
            queryClient.setQueryData([
                "profile"
            ], function() {
                return null;
            });
            queryClient.setQueryData([
                "authRedirectResult"
            ], function() {
                return null;
            });
            replace("/", undefined, {
                shallow: true
            });
        }
    });
    var isError = mutation.isError, error = mutation.error;
    (0,useCatchAuthErrorWithToast/* default */.Z)({
        isError: isError,
        error: error,
        defaultErrorMessage: "\uD68C\uC6D0\uD0C8\uD1F4\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694!"
    });
    return mutation;
}
/* harmony default export */ var auth_useSignOut = (useSignOut);

// EXTERNAL MODULE: ./src/recoil/modal/atom.ts
var atom = __webpack_require__(68453);
;// CONCATENATED MODULE: ./src/containers/common/HeaderContainer.tsx








function HeaderContainer() {
    var pathname = (0,router.useRouter)().pathname;
    var setSignInModalVisible = (0,es/* useSetRecoilState */.Zl)(atom/* signInModalVisibleState */.PJ);
    var ref = (0,useFetchUserProfile/* default */.Z)(), user = ref.data, isLoading = ref.isLoading;
    var mutate = auth_useSignOut().mutate;
    var ref1 = (0,react.useState)(true), isScrollTop = ref1[0], setIsScrollTop = ref1[1];
    var onClickSignIn = function() {
        return setSignInModalVisible(true);
    };
    var signOut = (0,react.useCallback)(function() {
        return mutate();
    }, [
        mutate
    ]);
    var handleScrollAction = (0,react.useCallback)(function() {
        return setIsScrollTop(window.scrollY === 0);
    }, []);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScrollAction);
        return function() {
            return window.removeEventListener("scroll", handleScrollAction);
        };
    }, [
        handleScrollAction
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(common_Header, {
        signOut: signOut,
        isScrollTop: isScrollTop,
        onClick: onClickSignIn,
        user: user,
        hasBackground: pathname === "/",
        hasOnlyLogo: pathname === "/signup",
        isLoading: isLoading
    });
}
/* harmony default export */ var common_HeaderContainer = (HeaderContainer);


/***/ }),

/***/ 26884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var firebase_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70065);
/* harmony import */ var _utils_toast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22659);




function useCatchAuthErrorWithToast(param) {
    var isError = param.isError, error = param.error, defaultErrorMessage = param.defaultErrorMessage;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var CREDENTIAL_TOO_OLD_LOGIN_AGAIN = firebase_auth__WEBPACK_IMPORTED_MODULE_1__/* .AuthErrorCodes.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ .kq.CREDENTIAL_TOO_OLD_LOGIN_AGAIN, TIMEOUT = firebase_auth__WEBPACK_IMPORTED_MODULE_1__/* .AuthErrorCodes.TIMEOUT */ .kq.TIMEOUT, TOO_MANY_ATTEMPTS_TRY_LATER = firebase_auth__WEBPACK_IMPORTED_MODULE_1__/* .AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER */ .kq.TOO_MANY_ATTEMPTS_TRY_LATER, TOKEN_EXPIRED = firebase_auth__WEBPACK_IMPORTED_MODULE_1__/* .AuthErrorCodes.TOKEN_EXPIRED */ .kq.TOKEN_EXPIRED;
        var _obj;
        var authErrorMessage = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, CREDENTIAL_TOO_OLD_LOGIN_AGAIN, "\uB2E4\uC2DC \uB85C\uADF8\uC778 \uD6C4 \uC9C4\uD589\uD574\uC8FC\uC138\uC694."), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, TIMEOUT, "\uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694."), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, TOO_MANY_ATTEMPTS_TRY_LATER, "\uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694."), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, TOKEN_EXPIRED, "\uD1A0\uD070\uC774 \uB9CC\uB8CC\uB418\uC5C8\uC5B4\uC694. \uB2E4\uC2DC \uB85C\uADF8\uC778 \uD6C4 \uC9C4\uD589\uD574\uC8FC\uC138\uC694."), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "unknown", "\uC54C \uC218 \uC5C6\uB294 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4."), _obj);
        if (!isError && !error) {
            return;
        }
        if (isError && !error) {
            (0,_utils_toast__WEBPACK_IMPORTED_MODULE_2__/* .errorToast */ .Jc)(defaultErrorMessage);
            return;
        }
        (0,_utils_toast__WEBPACK_IMPORTED_MODULE_2__/* .errorToast */ .Jc)(authErrorMessage[(error === null || error === void 0 ? void 0 : error.code) || "unknown"]);
    }, [
        isError,
        error,
        defaultErrorMessage
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useCatchAuthErrorWithToast);


/***/ }),

/***/ 53740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useBoolean() {
    var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialValue), state = ref[0], setState = ref[1];
    var setTrue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return setState(true);
    }, []);
    var setFalse = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return setState(false);
    }, []);
    var onToggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(nextValue) {
        return setState(function(prevState) {
            if (typeof nextValue === "boolean") {
                return nextValue;
            }
            return !prevState;
        });
    }, []);
    return [
        state,
        setTrue,
        setFalse,
        onToggle
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useBoolean);


/***/ }),

/***/ 72407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ initialWriteFieldsState; },
/* harmony export */   "z": function() { return /* binding */ positionOption; }
/* harmony export */ });
var initialWriteFieldsState = {
    title: "",
    content: "",
    tags: [],
    category: "",
    recruitmentEndDate: "",
    recruitmentEndSetting: "automatic",
    shortDescription: "",
    thumbnail: null
};
var positionOption = [
    {
        label: "\uD504\uB860\uD2B8\uC5D4\uB4DC",
        value: "\uD504\uB860\uD2B8\uC5D4\uB4DC"
    },
    {
        label: "\uBC31\uC5D4\uB4DC",
        value: "\uBC31\uC5D4\uB4DC"
    },
    {
        label: "\uD559\uC0DD",
        value: "\uD559\uC0DD"
    },
    {
        label: "\uB514\uC790\uC778",
        value: "\uB514\uC790\uC778"
    }, 
];


/***/ }),

/***/ 84029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ groupsConditionState; },
/* harmony export */   "g": function() { return /* binding */ writeFieldsState; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var _models_group__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72407);
/* harmony import */ var _services_storage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2138);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55208);




var groupsConditionState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "groupsConditionState",
    default: {
        category: [
            "study",
            "project"
        ],
        isFilterCompleted: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .trueOrFalse */ .Pz)((0,_services_storage__WEBPACK_IMPORTED_MODULE_3__/* .loadItem */ .oi)("isFilterCompleted")),
        tag: ""
    }
});
var writeFieldsState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "writeFieldsState",
    default: _models_group__WEBPACK_IMPORTED_MODULE_1__/* .initialWriteFieldsState */ .f
});


/***/ }),

/***/ 1249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fj": function() { return /* binding */ getUserAlertAlarm; },
/* harmony export */   "Gx": function() { return /* binding */ getUserAlarms; },
/* harmony export */   "Iw": function() { return /* binding */ patchAlarmViewed; },
/* harmony export */   "ve": function() { return /* binding */ postAddAlarm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var firebase_firestore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25321);
/* harmony import */ var _utils_firestore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50467);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55208);
/* harmony import */ var _firebase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96441);









var ALARMS = "alarms";
var postAddAlarm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        var id;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .addDoc */ .ET)((0,_firebase__WEBPACK_IMPORTED_MODULE_4__/* .collectionRef */ .JC)(ALARMS), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, form), {
                        isViewed: false,
                        createdAt: (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .serverTimestamp */ .Bt)()
                    }));
                case 2:
                    id = _ctx.sent.id;
                    return _ctx.abrupt("return", id);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postAddAlarm(form) {
        return _ref.apply(this, arguments);
    };
}();
var getUserAlarms = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(userUid, param) {
        var _perPage, perPage, lastUid, alarmsRef, commonQueries, isLengthLessThanPerPage, getQuery, response, lastVisible, alarms, lastGroupRef, getQuery1, response1, alarms1, lastVisible1, alarms2;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _perPage = param.perPage, perPage = _perPage === void 0 ? 10 : _perPage, lastUid = param.lastUid;
                    alarmsRef = (0,_firebase__WEBPACK_IMPORTED_MODULE_4__/* .collectionRef */ .JC)(ALARMS);
                    commonQueries = [
                        (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .where */ .ar)("userUid", "==", userUid),
                        (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .orderBy */ .Xo)("createdAt", "desc")
                    ];
                    isLengthLessThanPerPage = (0,_utils_firestore__WEBPACK_IMPORTED_MODULE_2__/* .isLessThanPerPage */ .h3)(perPage);
                    if (lastUid) {
                        _ctx.next = 14;
                        break;
                    }
                    getQuery = firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .query.apply */ .IO.apply(void 0, [
                        alarmsRef, 
                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(commonQueries), [
                        (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .limit */ .b9)(perPage), 
                    ]));
                    _ctx.next = 8;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .getDocs */ .PL)(getQuery);
                case 8:
                    response = _ctx.sent;
                    lastVisible = response.docs[response.docs.length - 1];
                    _ctx.next = 12;
                    return Promise.all((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(response.docs.map(_utils_firestore__WEBPACK_IMPORTED_MODULE_2__/* .formatAlarm */ .eo)));
                case 12:
                    alarms = _ctx.sent;
                    return _ctx.abrupt("return", {
                        items: alarms,
                        lastUid: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .targetFalseThenValue */ .E)(isLengthLessThanPerPage(response))(lastVisible === null || lastVisible === void 0 ? void 0 : lastVisible.id)
                    });
                case 14:
                    _ctx.next = 16;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .getDoc */ .QT)((0,_firebase__WEBPACK_IMPORTED_MODULE_4__/* .docRef */ .Db)(ALARMS, lastUid));
                case 16:
                    lastGroupRef = _ctx.sent;
                    getQuery1 = firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .query.apply */ .IO.apply(void 0, [
                        alarmsRef, 
                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(commonQueries), [
                        (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .startAfter */ .TQ)(lastGroupRef),
                        (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .limit */ .b9)(perPage), 
                    ]));
                    _ctx.next = 20;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .getDocs */ .PL)(getQuery1);
                case 20:
                    response1 = _ctx.sent;
                    if (!isLengthLessThanPerPage(response1)) {
                        _ctx.next = 26;
                        break;
                    }
                    _ctx.next = 24;
                    return Promise.all((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(response1.docs.map(_utils_firestore__WEBPACK_IMPORTED_MODULE_2__/* .formatAlarm */ .eo)));
                case 24:
                    alarms1 = _ctx.sent;
                    return _ctx.abrupt("return", {
                        items: alarms1
                    });
                case 26:
                    lastVisible1 = response1.docs[response1.docs.length - 1];
                    _ctx.next = 29;
                    return Promise.all((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(response1.docs.map(_utils_firestore__WEBPACK_IMPORTED_MODULE_2__/* .formatAlarm */ .eo)));
                case 29:
                    alarms2 = _ctx.sent;
                    return _ctx.abrupt("return", {
                        items: alarms2,
                        lastUid: lastVisible1 === null || lastVisible1 === void 0 ? void 0 : lastVisible1.id
                    });
                case 31:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getUserAlarms(userUid, _) {
        return _ref.apply(this, arguments);
    };
}();
var getUserAlertAlarm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(userUid) {
        var getQuery, response;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    getQuery = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .query */ .IO)((0,_firebase__WEBPACK_IMPORTED_MODULE_4__/* .collectionRef */ .JC)(ALARMS), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .where */ .ar)("userUid", "==", userUid), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .where */ .ar)("isViewed", "==", false));
                    _ctx.next = 3;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .getDocs */ .PL)(getQuery);
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.docs.map(_utils_firestore__WEBPACK_IMPORTED_MODULE_2__/* .formatCreatedAt */ .Qg));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getUserAlertAlarm(userUid) {
        return _ref.apply(this, arguments);
    };
}();
var patchAlarmViewed = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(uid) {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,_firebase__WEBPACK_IMPORTED_MODULE_4__/* .docRef */ .Db)(ALARMS, uid), {
                        isViewed: true
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function patchAlarmViewed(uid) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ DetailLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var facepaint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9401);




/* eslint-disable react/jsx-props-no-spreading */ 


var mq1 = (0,facepaint__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)([
    "@media(min-width: 1100px)", 
]);
var mq2 = (0,facepaint__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)([
    "@media(min-width: 700px)", 
]);
function Layout(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(LayoutWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        children: children
    }));
}
var DetailLayout = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Layout, {
    target: "e1n9w15t0"
})(mq2({
    width: [
        "calc(100% - 2rem)",
        "686px"
    ]
}), ";");
var LayoutWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e1n9w15t1"
})("margin-left:auto;margin-right:auto;padding-left:1rem;padding-right:1rem;", mq1({
    width: [
        "calc(100% - 3rem)",
        "1040px"
    ]
}), ";");
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 50467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qg": function() { return /* binding */ formatCreatedAt; },
/* harmony export */   "ec": function() { return /* binding */ formatComment; },
/* harmony export */   "eo": function() { return /* binding */ formatAlarm; },
/* harmony export */   "h3": function() { return /* binding */ isLessThanPerPage; },
/* harmony export */   "jV": function() { return /* binding */ timestampToString; },
/* harmony export */   "p_": function() { return /* binding */ formatGroup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_api_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59155);





var timestampToString = function(timestamp) {
    return timestamp.toDate().toString();
};
var formatGroup = function(group) {
    var createdAt = group.data().createdAt;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, group.data()), {
        groupId: group.id,
        createdAt: timestampToString(createdAt)
    });
};
var formatComment = function(comment) {
    var createdAt = comment.data().createdAt;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, comment.data()), {
        commentId: comment.id,
        createdAt: timestampToString(createdAt)
    });
};
var formatCreatedAt = function(applicant) {
    var createdAt = applicant.data().createdAt;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, applicant.data()), {
        uid: applicant.id,
        createdAt: timestampToString(createdAt)
    });
};
var formatAlarm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(alarm) {
        var ref, createdAt, group, userUid, isViewed, type, applicantUid, convertedAlarm, applicant;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = alarm.data(), createdAt = ref.createdAt, group = ref.group, userUid = ref.userUid, isViewed = ref.isViewed, type = ref.type, applicantUid = ref.applicantUid;
                    convertedAlarm = {
                        uid: alarm.id,
                        userUid: userUid,
                        group: group,
                        type: type,
                        isViewed: isViewed,
                        createdAt: timestampToString(createdAt)
                    };
                    if (!applicantUid) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 5;
                    return (0,_services_api_auth__WEBPACK_IMPORTED_MODULE_1__/* .getUserProfile */ .et)(applicantUid);
                case 5:
                    applicant = _ctx.sent;
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, convertedAlarm), {
                        applicant: applicant
                    }));
                case 7:
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, convertedAlarm), {
                        applicant: null
                    }));
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function formatAlarm(alarm) {
        return _ref.apply(this, arguments);
    };
}();
var isLessThanPerPage = function(perPage) {
    return function(documentData) {
        return documentData.empty || documentData.docs.length < perPage;
    };
};


/***/ })

}]);